import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DOMPurify from "dompurify";
import { TOKENS } from "./styled";

type Props = {
  open: boolean;
  title: string;
  html: string | null | undefined;
  onClose: () => void;
};

const LegalModal: React.FC<Props> = ({ open, title, html, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    scroll="paper"
    aria-labelledby="legal-modal-title"
  >
    <DialogTitle
      id="legal-modal-title"
      sx={{ pr: 6, color: TOKENS.PRIMARY_BLUE, fontWeight: 700 }}
    >
      {title}
      <IconButton
        aria-label="Fermer"
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8, color: TOKENS.GRAY_500 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      {html ? (
        <Box
          sx={{
            color: TOKENS.GRAY_800,
            fontSize: "0.92rem",
            lineHeight: 1.65,
            "& h2": {
              color: TOKENS.PRIMARY_BLUE,
              fontSize: "1.25rem",
              mt: 0,
              mb: 1.5,
            },
            "& h3": {
              color: TOKENS.PRIMARY_BLUE,
              fontSize: "1.05rem",
              mt: 2.5,
              mb: 0.75,
            },
            "& p": { my: 1 },
            "& ul": { pl: 3, my: 1 },
            "& li": { mb: 0.5 },
            "& a": { color: TOKENS.ACCENT_BLUE },
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(html, {
              ADD_ATTR: ["target", "rel"],
            }),
          }}
        />
      ) : (
        <Typography sx={{ color: TOKENS.GRAY_500, fontStyle: "italic" }}>
          Ce document n&apos;est pas encore disponible.
        </Typography>
      )}
    </DialogContent>
  </Dialog>
);

export default LegalModal;
